import {Dialog} from 'platform/components';
import {HStack, Text, VStack} from 'platform/foundation';

import {isNil} from 'ramda';

import {OnlineOfferAlternative} from '../../../api/types/onlineOfferAlternativesTypes';
import {Button} from '../../../components/Button/Button';
import {useFormatAlternativeTotal} from '../../../hooks/useFormatAlternativeTotal';
import {getAlternativeLabel} from '../../../utils/getAlternativeLabel';
import {translateWithFallback as t} from '../../../utils/translateWithFallback';

interface ChooseAlternativeDialogProps {
  alternative: OnlineOfferAlternative | null;
  isChoosing: boolean;
  onConfirm: VoidFunction;
  onCancel: VoidFunction;
}

export function ChooseAlternativeDialog(props: ChooseAlternativeDialogProps) {
  const formatTotal = useFormatAlternativeTotal();

  if (isNil(props.alternative)) {
    return null;
  }

  return (
    <Dialog
      isOpen
      size="small"
      title={t('alternatives.choice.dialogTitle', 'Select {label}', {
        label: getAlternativeLabel(props.alternative),
      })}
      onClose={props.onCancel}
      data-testid="chooseAlternativeDialog"
    >
      <VStack spacing={4}>
        <Text>
          {t('alternatives.choice.dialogSummary', 'You prefer {title} for {price} incl. VAT.', {
            title: props.alternative.title,
            price: formatTotal(props.alternative),
          })}
        </Text>
        <Text size="small" color="secondary">
          {t(
            'alternatives.choice.nonBinding',
            'This confirms your preference only. It does not sign a contract, order a vehicle or create a reservation.'
          )}
        </Text>
        <HStack spacing={2} justify="flex-end">
          <Button
            variant="outline"
            title={t('alternatives.choice.cancel', 'Cancel')}
            onClick={props.onCancel}
            data-testid="chooseAlternativeDialog-cancel"
          />
          <Button
            variant="primary"
            title={t('alternatives.choice.confirm', 'Confirm my selection')}
            isDisabled={props.isChoosing}
            onClick={props.onConfirm}
            data-testid="chooseAlternativeDialog-confirm"
          />
        </HStack>
      </VStack>
    </Dialog>
  );
}
